import React, { useState, useRef } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import '../../assets/css/FxCss.css'
import { Button, Container, Stack } from 'react-bootstrap';

const MainSlider = ({scrollToContactUs}) => {
    const [index, setIndex] = useState(0);
    const carouselRef = useRef(null);
 
    const handleVideoEnd = () => {
        const newIndex = (index + 1) % 2; // Assuming you have 2 carousel items

        if (newIndex === 0) {
            setIndex(newIndex);
        } else {
            // Reset index to 0 if the second video ends
            setIndex(0);
        }

        if (carouselRef.current) {
            carouselRef.current.next();
        }

        // Auto-play the video when the slide changes
        const videos = document.querySelectorAll('.MainSliderVideo');
        videos.forEach((video, idx) => {
            if (idx === newIndex) {
                video.play();
            } else {
                video.pause();
            }
        });
    };

   


    return (
        <>
            <Container className='slidercontainer'style={{
                marginTop:'10rem'
            }}>
                    <Stack direction='vertical' gap={2}>
                        <Stack className='mb-2 bannerIcon' direction='vertical' gap={2} style={{
                            justifyContent:'center',
                            alignItems:'center'
                        }}>
                            <h3 className='text-center'>Sell Smarter and Support Faster with Immersive 3D Product Experiences Powered by AI.<br/></h3>
                            <h1><span style={{ color: '#0F75D6', fontWeight: 'bold', textAlign:'center' }}>FXperience for VisionPro, VR Headsets & Mobile Web</span></h1>
                        <Stack className='mb-2 bannerIcon' direction='horizontal' gap={2} style={{
                            justifyContent:'center',
                            alignItems:'center'
                        }}>
                             <Button variant='outlined'  className='rounded-5'  onClick={scrollToContactUs}>Get In Touch</Button>
                             <Button variant='primary' className='rounded-5'  onClick={scrollToContactUs}>Book a demo</Button>
                           </Stack>
                        </Stack>
                    </Stack>
                <Carousel ref={carouselRef} activeIndex={index} onSelect={setIndex} controls={false} interval={null}>
                    <Carousel.Item>
                        <video className='img-fluid MainSliderVideo' autoPlay muted onEnded={handleVideoEnd}>
                            <source src='/fexperience/assets/video/Game/F-Video06.mp4' type='video/mp4' />
                            Your browser does not support the video tag.
                        </video>
                    </Carousel.Item>
                    <Carousel.Item>
                        <video className='img-fluid MainSliderVideo' autoPlay muted onEnded={handleVideoEnd}>
                            <source src='/fexperience/assets/video/Game/F-Video07.mp4' type='video/mp4' />
                            Your browser does not support the video tag.
                        </video>
                    </Carousel.Item>
                </Carousel>
            </Container>
        </>
    )
}

export default MainSlider;
